<template>
  <div class="animated fadeIn py3 darkblue notosans">
    <div class="clearfix px3 mpx1 mb2">
      <div class="col-12 px0">
        <!-- <div class="clearfix border muted-border p2 py3 shadow" v-if="showMobile">
          <div class="col-12 mt3 ">
            <p class="h4 semi-bold line-height-2 my2 darkblue">Opret projekter og fremvis dit flotte arbejde</p>
            <p class="h5 regular darkblue line-height-golden mb0">
              Her kan du oprette projekter ved at uploade billeder af dit arbejde og skrive hvad du har lavet på opgaven.
            </p>
            <p class="h5 regular darkblue line-height-golden mb0">
              <span class="semi-bold block">Sådan gør du:</span>
            </p>
            <ol class="pl2">
              <li>
                Upload billederne af dit projekt
              </li>
              <li>
                Vælg opgavetype, giv projektet en titel og beskriv projektet
              </li>
              <li>
                Tryk på “Færdig” - så modtager vi informationerne og lægger projektet på Håndværker.dk
              </li>
            </ol>
          </div>
          <div class="clearfix relative mt3">
            <div v-if="miniprofile" class="darkblue-background py4 my2 absolute left-0 right-0 top-0 bottom-0 z2 col-12 flex flex-column justify-start items-start">
              <p class="h5 line-height-golden  white mt4 mb2" style="">
                Som basismedlem har du desværre ikke adgang til denne del af partner-login.
              </p>
              <p class="h5 line-height-golden  white mb2" style="">
                Opgrader din løsning, hvis du vil have adgang.
              </p>
              <button class="p2 white-button  h5 line-height-1 not-rounded border-none flex justify-center items-center">
                <span>Kontakt mig</span>
                <span class="mx2"><i class="el-icon-right"></i></span>
              </button>
            </div>
            <div class="relative">
              <createnew :projects="projects" :projects_create="projects_create" @UpdateProject="UpdateProject"></createnew>
            </div>
          </div>
        </div> -->
        <div class="clearfix px2 py3 mpx1 ml4 mm0">
          <div class="col-12 mt3">
            <p class="h4 semi-bold line-height-2 my2 darkblue">Opret projekter og fremvis dit flotte arbejde</p>
            <p class="h6 regular darkblue line-height-golden mb2">
              Her kan du oprette projekter ved at uploade billeder af dit arbejde og skrive hvad du har lavet på opgaven.
              <br><br>
              <span class="semi-bold block darkblue p0 m0">Sådan gør du:</span>
            </p>
            <ol class="pl2">
              <li class="mb2">
                <span class="h6 regular pl2 flex">Upload billederne af dit projekt</span>
              </li>
              <li class="mb2">
                <span class="h6 regular pl2 flex">Vælg opgavetype, giv projektet en titel og beskriv projektet</span>
              </li>
              <li class="mb2">
                <span class="h6 regular pl2 flex">Tryk på “Færdig” - så modtager vi informationerne og lægger projektet på Håndværker.dk</span>
              </li>
            </ol>
          </div>
          <div class="clearfix"></div>
          <div class="clearfix mt3" v-if="!minprofile">
            <div class="relative">
              <div class="col-12">
                <button @click="gotocreateproject()" class="action-button p2 h4 line-height-1 regular line-height-1 fles justify-center items-center not-rounded border-none">
                  <span>Kom i gang</span>
                  <span class="mx2"><i class="el-icon-right"></i></span>
                </button>
              </div>
              <!-- <div class="col-12 mt3 pl0" v-if="seen">
                <createnew :projects="projects" :projects_create="projects_create" @UpdateProject="UpdateProject"></createnew>
              </div> -->
            </div>
          </div>
          <div class="clearfix mt3">
            <div v-if="miniprofile" class="transparent-darkblue-background py4 my2 absolute left-0 right-0 top-0 bottom-0 z2 col-12 flex flex-column justify-start items-start">
              <p class="h5 line-height-golden white mt4 mb2" style="">
                Som basismedlem har du desværre ikke adgang til denne del af partner-login.
              </p>
              <p class="h5 line-height-golden white mb2" style="">
                Opgrader din løsning, hvis du vil have adgang.
              </p>
              <button class="p2 white-button h5 line-height-1 not-rounded border-none flex justify-center items-center">
                <span>Kontakt mig</span>
                <span class="mx2"><i class="el-icon-right"></i></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py4"></div>
  </div>
</template>
<script>
import createnew from './CreateProjectNew'
export default {
  components: {
    createnew
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    var projectId = this.$route.query.id
    if (projectId !== undefined) {
      this.seen = true
    }
  },
  data: function () {
    return {
      projects: 0,
      projects_create: 0,
      seen: true,
      miniprofile: ''
    }
  },
  methods: {
    UpdateProject (projects, projectsCreate) {
      this.projects = projects
      this.projects_create = projectsCreate
    },
    gotocreateproject () {
      this.$router.push('/opret-projekt-new/wizard')
    }
  }
}
</script>
<style>
  @media (max-width:27em) {
    .mm0 {
      margin: 0px;
    }
    .mpx1 {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }
  li::marker {
    color: #19A3C0;
    font-size: 18px;
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// OpretProjektNew.vue?64443dcb